export default angular
    .module('bl.clientDetails', [])
    .name;


// WEBPACK FOOTER //
// src/public/javascripts/client-details/bb_client_deails.module.js